import { Draft, DraftState } from '@/types';
import { getIsUnprintableConfiguration } from '@/model/configuration/getIsUnprintableConfiguration';
import { getConfigurations } from '@/model/draft/getConfigurations';
import { removeConfiguration } from './helper/removeConfiguration';

export const cleanupDraft = (draft: Draft | DraftState) => {
  getConfigurations(draft).forEach((configuration) => {
    if (getIsUnprintableConfiguration(configuration)) {
      removeConfiguration(draft, configuration.cid);
    }
  });
};
